import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { useCart } from "@/hooks/useCart";

export default function CartPage() {
  const cart = useCart();

  return (
    <div className="min-h-screen bg-white text-neutral-800 flex flex-col">
      <SiteHeader variant="solid" />
      <main className="flex-1 pt-20 md:pt-24 bg-white">
        <section className="w-full px-6 md:px-10 py-10 md:py-14">
          <div className="max-w-5xl mx-auto">
            <p className="text-[10px] tracking-[0.24em] uppercase text-neutral-500 mb-3">Your Bag</p>
            <h1 className="text-[28px] md:text-[36px] leading-[1.05] tracking-[-0.01em] text-neutral-900 font-light mb-10">
              {cart.count === 0 ? "Your bag is empty." : `Bag · ${cart.count} item${cart.count === 1 ? "" : "s"}`}
            </h1>

            {cart.items.length === 0 ? (
              <Link to="/shop" className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white text-[13px] rounded-full transition cursor-pointer whitespace-nowrap">
                Start shopping <i className="ri-arrow-right-line"></i>
              </Link>
            ) : (
              <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
                <ul className="lg:col-span-8 divide-y divide-neutral-200">
                  {cart.items.map((it) => {
                    const key = cart.keyOf(it);
                    return (
                      <li key={key} className="py-6 flex gap-5">
                        <Link to={`/product/${it.slug}`} className="w-24 h-32 bg-neutral-50 overflow-hidden flex-shrink-0 cursor-pointer">
                          <img src={it.img} alt={it.name} className="w-full h-full object-contain object-center" />
                        </Link>
                        <div className="flex-1 min-w-0 flex flex-col">
                          <div className="flex items-start justify-between gap-4">
                            <div>
                              <Link to={`/product/${it.slug}`} className="text-[14px] text-neutral-900 hover:text-primary-600 cursor-pointer">
                                {it.name}
                              </Link>
                              <p className="text-[11px] text-neutral-500 mt-1">
                                {it.color}{it.size ? ` · Size ${it.size}` : ""}
                              </p>
                            </div>
                            <span className="text-[14px] text-neutral-900">${it.price * it.quantity}</span>
                          </div>
                          <div className="mt-auto pt-4 flex items-center justify-between">
                            <div className="flex items-center border border-neutral-200 rounded-full">
                              <button onClick={() => cart.updateQty(key, it.quantity - 1)} className="w-8 h-8 flex items-center justify-center text-neutral-600 hover:text-neutral-900 cursor-pointer" aria-label="Decrease">
                                <i className="ri-subtract-line text-sm"></i>
                              </button>
                              <span className="w-7 text-center text-[12px]">{it.quantity}</span>
                              <button onClick={() => cart.updateQty(key, it.quantity + 1)} className="w-8 h-8 flex items-center justify-center text-neutral-600 hover:text-neutral-900 cursor-pointer" aria-label="Increase">
                                <i className="ri-add-line text-sm"></i>
                              </button>
                            </div>
                            <button onClick={() => cart.remove(key)} className="text-[11px] text-neutral-500 hover:text-primary-600 cursor-pointer">Remove</button>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>

                <aside className="lg:col-span-4 lg:pl-8 lg:border-l lg:border-neutral-200">
                  <p className="text-[11px] tracking-[0.24em] uppercase text-neutral-500 mb-4">Summary</p>
                  <div className="space-y-3 text-[13px] text-neutral-700">
                    <div className="flex items-center justify-between">
                      <span>Subtotal</span>
                      <span>${cart.subtotal}</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span>Shipping</span>
                      <span>{cart.subtotal >= 150 ? "Free" : "$12"}</span>
                    </div>
                    <div className="flex items-center justify-between pt-3 border-t border-neutral-200 text-neutral-900 text-[15px]">
                      <span>Total</span>
                      <span>${cart.subtotal + (cart.subtotal >= 150 ? 0 : 12)}</span>
                    </div>
                  </div>
                  <Link to="/checkout" className="mt-6 w-full inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-primary-500 hover:bg-primary-600 text-white text-[13px] rounded-full transition cursor-pointer whitespace-nowrap">
                    Continue to checkout <i className="ri-arrow-right-line"></i>
                  </Link>
                  <Link to="/shop" className="mt-3 w-full inline-flex items-center justify-center text-[12px] tracking-[0.15em] uppercase text-neutral-700 hover:text-neutral-900 cursor-pointer">
                    Continue shopping
                  </Link>
                </aside>
              </div>
            )}
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}